module.exports = __webpack_public_path__ + "static/media/location-a.3487ea5f.svg";